import React, { useState, useEffect, useRef } from 'react';

// material ui
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import TextField from '@material-ui/core/TextField';

import useStyles from './styles';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import ChevronRight from '@material-ui/icons/ChevronRight';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import InfoButton from '../../../../../components/InfoButton';


function SubForm07({ id, setValue, saveValue, saveValueJump, value, kb, handleNextSub, navigationMode, handleBackSub, no_kk, isSubmitting, setKB }) {

    const nextRef = useRef(null);
    const backRef = useRef(null);

    const classes = useStyles();
    const [error, setError] = useState({});
    const [useModernContrasep, setUseModernContrasep] = useState(false);

    const [tmptPelayanan, setTmptPelayanan] = useState(value.tempat_pelayanan || '')
    const [lainnya, setLainnya] = useState(value.tempat_pelayanan_lainnya || '')

    const pertanyaan = "Sumber mendapatkan pelayanan alat/obat/cara kontrasepsi terakhir?";

    useEffect(() => {

        let pelayananLain = ""

        if (tmptPelayanan == "14") {
            pelayananLain = lainnya
        }

        let normalizeValue = {
            _id: `${no_kk}${id}`,
            Pertanyaan: pertanyaan,
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            Jawaban_HDate1: "",
            Jawaban_HDate2: "",
            No_Pertanyaan: 7,
            No_KK: no_kk,
            answer: [
                {
                    _id: `${no_kk}${id}01`,
                    No_Jawaban: tmptPelayanan,
                    Jawaban_D1: 0,
                    Jawaban_D2: 0,
                    Jawab_D3: 0,
                    Jawab_D4: 0,
                    pilihankb: 0,
                    Lainnya: pelayananLain ? pelayananLain : ""
                },

            ]

        }
        if (value._rev) {
            normalizeValue._rev = value._rev
        }

        saveValueJump(normalizeValue)

    }, [tmptPelayanan, lainnya])

    useEffect(() => {
        setError({})

        // if ((kb["0107"].jenis_kontrasepsi !== "9") || (kb["0104"].menggunakan_kontrasepsi === "1" && kb["0105"].pernah_menggunakan_kontrasepsi === "1")) {
        // // if (kb["0103"].sedang_hamil === "1"  && kb["0104"].menggunakan_kontrasepsi === "1" && kb["0105"].pernah_menggunakan_kontrasepsi === "1"  ) {
        //     setUseModernContrasep(true);
        // } else {
        //     if (navigationMode === 'back') {
        //         handleBackSub();
        //     } else {
        //         handleNextSub()
        //     }
        // }

        /* cek kondisi untuk semua form */
        if (kb["0102"].sedang_hamil === "2" && kb["0103"].menggunakan_kontrasepsi === "2" && kb["0104"].pernah_menggunakan_kontrasepsi === "1") {
            if (kb["0106"].jenis_kontrasepsi === "9") {
                // skip
                let normalizeValue = {}
                setKB({
                    ...kb,
                    [id]: {
                        ...kb[id],
                        ["tempat_pelayanan"]: undefined
                    }
                })

                if (navigationMode === 'back') {
                    handleBackSub();
                } else {
                    handleNextSub()
                    saveValueJump(normalizeValue)
                }
            } else {
                // jalan
                setUseModernContrasep(true);
            }
        } else if (kb["0102"].sedang_hamil === "1" && kb["0104"].pernah_menggunakan_kontrasepsi === "2") {

            let normalizeValue = {}
            setKB({
                ...kb,
                [id]: {
                    ...kb[id],
                    ["tempat_pelayanan"]: undefined
                }
            })
            if (navigationMode === 'back') {
                handleBackSub();
            } else {
                handleNextSub()
                saveValueJump(normalizeValue)
            }
        } else {
            if (kb["0102"].sedang_hamil === "2" && kb["0103"].menggunakan_kontrasepsi === "2" && kb["0104"].pernah_menggunakan_kontrasepsi === "2") {

                let normalizeValue = {}
                setKB({
                    ...kb,
                    [id]: {
                        ...kb[id],
                        ["tempat_pelayanan"]: undefined
                    }
                })
                if (navigationMode === 'back') {
                    handleBackSub();
                } else {
                    handleNextSub()
                    saveValueJump(normalizeValue)
                }


            } else {
                if (kb["0106"].jenis_kontrasepsi === "9") {
                    // skip
                    let normalizeValue = {}
                    setKB({
                        ...kb,
                        [id]: {
                            ...kb[id],
                            ["tempat_pelayanan"]: undefined
                        }
                    })
                    if (navigationMode === 'back') {
                        handleBackSub();
                    } else {
                        handleNextSub()
                        saveValueJump(normalizeValue)
                    }
                } else {
                    // jalan
                    setUseModernContrasep(true);
                }

            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (!useModernContrasep) {
        return null
    }

    const handleChange = (e) => {

        setValue(e)

        setError({
            ...error,
            [e.target.name]: ""
        })

        switch (e.target.name) {
            case 'tempat_pelayanan':
            setTmptPelayanan(e.target.value)
            break;
            case 'tempat_pelayanan_lainnya':
            setLainnya(e.target.value)
            break;
            default:
                break;
        }

        // setSomethingChange(true)
    }

    const validate = () => {
        let newError = {};

        if (!value.tempat_pelayanan) {
            newError.tempat_pelayanan = "Wajib diisi";
        }

        if (value.tempat_pelayanan === "14") {
            if (!value.tempat_pelayanan_lainnya) {
                newError.tempat_pelayanan_lainnya = "Lainnya wajib diisi";
            }
        }
        return newError;
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        const findErrors = validate();

        const errorValues = Object.values(findErrors);

        if (errorValues.length > 0 && errorValues.some(err => err !== '')) {
            setError(findErrors);
        } else {

            let normalizeValue = {
                _id: `${no_kk}${id}`,
                Pertanyaan: pertanyaan,
                Jawaban_H1: 0,
                Jawaban_H2: 0,
                Jawaban_HDate1: "",
                Jawaban_HDate2: "",
                No_Pertanyaan: 7,
                No_KK: no_kk,
                answer: [
                    {
                        _id: `${no_kk}${id}01`,
                        No_Jawaban: value.tempat_pelayanan,
                        Jawaban_D1: 0,
                        Jawaban_D2: 0,
                        Jawab_D3: 0,
                        Jawab_D4: 0,
                        pilihankb: 0,
                        Lainnya: value.tempat_pelayanan_lainnya ? value.tempat_pelayanan_lainnya : ""
                    },

                ]

            }
            if (value._rev) {
                normalizeValue._rev = value._rev
            }

            saveValue(normalizeValue)
        }
    }

    const renderSwitchKB7 = (kb6) => {
        switch (kb6) {
            case '1':
                return <><div className={classes.radioSection}>
                        <FormControlLabel control={<Radio />}
                            value="1"
                            label="1. Rumah sakit umum" />
                        <FormControlLabel control={<Radio />}
                            value="2"
                            label="2. Rumah sakit khusus" />
                        <FormControlLabel control={<Radio />}
                            value="3"
                            label="3. Klinik utama" />
                    </div></>;
            case '2':
                return <><div className={classes.radioSection}>
                        <FormControlLabel control={<Radio />}
                            value="1"
                            label="1. Rumah sakit umum" />
                        <FormControlLabel control={<Radio />}
                            value="2"
                            label="2. Rumah sakit khusus" />
                        <FormControlLabel control={<Radio />}
                            value="3"
                            label="3. Klinik utama" />
                        <FormControlLabel control={<Radio />}
                            value="4"
                            label="4. Puskesmas" />
                    </div>

                    <div className={classes.radioSection}>
                        <FormControlLabel control={<Radio />}
                            value="5"
                            label="5. Praktik dokter" />
                        <FormControlLabel control={<Radio />}
                            value="6"
                            label="6. Klinik pratama" />
                        <FormControlLabel control={<Radio />}
                            value="7"
                            label="7. Rumah sakit tipe D pratama" />
                        <FormControlLabel control={<Radio />}
                            value="12"
                            label="12. Mobil pelayanan kontrasepsi" />
                    </div></>;
            case '3':
                return <><div className={classes.radioSection}>
                        <FormControlLabel control={<Radio />}
                            value="1"
                            label="1. Rumah sakit umum" />
                        <FormControlLabel control={<Radio />}
                            value="2"
                            label="2. Rumah sakit khusus" />
                        <FormControlLabel control={<Radio />}
                            value="3"
                            label="3. Klinik utama" />
                        <FormControlLabel control={<Radio />}
                            value="4"
                            label="4. Puskesmas" />
                        <FormControlLabel control={<Radio />}
                            value="5"
                            label="5. Praktik dokter" />
                        <FormControlLabel control={<Radio />}
                            value="6"
                            label="6. Klinik pratama" />
                    </div>

                    <div className={classes.radioSection}>
                        <FormControlLabel control={<Radio />}
                            value="7"
                            label="7. Rumah sakit tipe D pratama" />
                        <FormControlLabel control={<Radio />}
                            value="8"
                            label="8. Tempat Praktik Mandiri Bidan (TPMB)" />
                        <FormControlLabel control={<Radio />}
                            value="9"
                            label="9. Pustu" />
                        <FormControlLabel control={<Radio />}
                            value="10"
                            label="10. Pusling" />
                        <FormControlLabel control={<Radio />}
                            value="11"
                            label="11. Poskesdes/polindes" />
                        <FormControlLabel control={<Radio />}
                            value="12"
                            label="12. Mobil pelayanan kontrasepsi" />
                    </div></>;
            case '4':
                return <><div className={classes.radioSection}>
                        <FormControlLabel control={<Radio />}
                            value="1"
                            label="1. Rumah sakit umum" />
                        <FormControlLabel control={<Radio />}
                            value="2"
                            label="2. Rumah sakit khusus" />
                        <FormControlLabel control={<Radio />}
                            value="3"
                            label="3. Klinik utama" />
                        <FormControlLabel control={<Radio />}
                            value="4"
                            label="4. Puskesmas" />
                        <FormControlLabel control={<Radio />}
                            value="5"
                            label="5. Praktik dokter" />
                        <FormControlLabel control={<Radio />}
                            value="6"
                            label="6. Klinik pratama" />
                    </div>

                    <div className={classes.radioSection}>
                        <FormControlLabel control={<Radio />}
                            value="7"
                            label="7. Rumah sakit tipe D pratama" />
                        <FormControlLabel control={<Radio />}
                            value="8"
                            label="8. Tempat Praktik Mandiri Bidan (TPMB)" />
                        <FormControlLabel control={<Radio />}
                            value="9"
                            label="9. Pustu" />
                        <FormControlLabel control={<Radio />}
                            value="10"
                            label="10. Pusling" />
                        <FormControlLabel control={<Radio />}
                            value="11"
                            label="11. Poskesdes/polindes" />
                        <FormControlLabel control={<Radio />}
                            value="12"
                            label="12. Mobil pelayanan kontrasepsi" />
                    </div></>;
            case '5':
                return <><div className={classes.radioSection}>
                        <FormControlLabel control={<Radio />}
                            value="1"
                            label="1. Rumah sakit umum" />
                        <FormControlLabel control={<Radio />}
                            value="2"
                            label="2. Rumah sakit khusus" />
                        <FormControlLabel control={<Radio />}
                            value="3"
                            label="3. Klinik utama" />
                        <FormControlLabel control={<Radio />}
                            value="4"
                            label="4. Puskesmas" />
                        <FormControlLabel control={<Radio />}
                            value="5"
                            label="5. Praktik dokter" />
                        <FormControlLabel control={<Radio />}
                            value="6"
                            label="6. Klinik pratama" />
                    </div>

                    <div className={classes.radioSection}>
                        <FormControlLabel control={<Radio />}
                            value="7"
                            label="7. Rumah sakit tipe D pratama" />
                        <FormControlLabel control={<Radio />}
                            value="8"
                            label="8. Tempat Praktik Mandiri Bidan (TPMB)" />
                        <FormControlLabel control={<Radio />}
                            value="9"
                            label="9. Pustu" />
                        <FormControlLabel control={<Radio />}
                            value="10"
                            label="10. Pusling" />
                        <FormControlLabel control={<Radio />}
                            value="11"
                            label="11. Poskesdes/polindes" />
                        <FormControlLabel control={<Radio />}
                            value="12"
                            label="12. Mobil pelayanan kontrasepsi" />
                    </div></>;
            case '6':
                return <><div className={classes.radioSection}>
                        <FormControlLabel control={<Radio />}
                            value="1"
                            label="1. Rumah sakit umum" />
                        <FormControlLabel control={<Radio />}
                            value="2"
                            label="2. Rumah sakit khusus" />
                        <FormControlLabel control={<Radio />}
                            value="3"
                            label="3. Klinik utama" />
                        <FormControlLabel control={<Radio />}
                            value="4"
                            label="4. Puskesmas" />
                        <FormControlLabel control={<Radio />}
                            value="5"
                            label="5. Praktik dokter" />
                        <FormControlLabel control={<Radio />}
                            value="6"
                            label="6. Klinik pratama" />
                        <FormControlLabel control={<Radio />}
                            value="7"
                            label="7. Rumah sakit tipe D pratama" />
                    </div>

                    <div className={classes.radioSection}>
                        <FormControlLabel control={<Radio />}
                            value="8"
                            label="8. Tempat Praktik Mandiri Bidan (TPMB)" />
                        <FormControlLabel control={<Radio />}
                            value="9"
                            label="9. Pustu" />
                        <FormControlLabel control={<Radio />}
                            value="10"
                            label="10. Pusling" />
                        <FormControlLabel control={<Radio />}
                            value="11"
                            label="11. Poskesdes/polindes" />
                        <FormControlLabel control={<Radio />}
                            value="12"
                            label="12. Mobil pelayanan kontrasepsi" />
                        <FormControlLabel control={<Radio />}
                            value="13"
                            label="13. Toko obat/apotek" />
                    </div></>;
            case '7':
                return <><div className={classes.radioSection}>
                        <FormControlLabel control={<Radio />}
                            value="1"
                            label="1. Rumah sakit umum" />
                        <FormControlLabel control={<Radio />}
                            value="2"
                            label="2. Rumah sakit khusus" />
                        <FormControlLabel control={<Radio />}
                            value="3"
                            label="3. Klinik utama" />
                        <FormControlLabel control={<Radio />}
                            value="4"
                            label="4. Puskesmas" />
                        <FormControlLabel control={<Radio />}
                            value="5"
                            label="5. Praktik dokter" />
                        <FormControlLabel control={<Radio />}
                            value="6"
                            label="6. Klinik pratama" />
                        <FormControlLabel control={<Radio />}
                            value="7"
                            label="7. Rumah sakit tipe D pratama" />
                    </div>

                    <div className={classes.radioSection}>
                        <FormControlLabel control={<Radio />}
                            value="8"
                            label="8. Tempat Praktik Mandiri Bidan (TPMB)" />
                        <FormControlLabel control={<Radio />}
                            value="9"
                            label="9. Pustu" />
                        <FormControlLabel control={<Radio />}
                            value="10"
                            label="10. Pusling" />
                        <FormControlLabel control={<Radio />}
                            value="11"
                            label="11. Poskesdes/polindes" />
                        <FormControlLabel control={<Radio />}
                            value="12"
                            label="12. Mobil pelayanan kontrasepsi" />
                        <FormControlLabel control={<Radio />}
                            value="13"
                            label="13. Toko obat/apotek" />
                        <FormControlLabel control={<Radio />}
                            value="14"
                            label="14. Lainnya" />
                        {value.tempat_pelayanan === "14" &&
                            <TextField
                                fullWidth
                                placeholder="Tuliskan"
                                variant="outlined"
                                id="tempat_pelayanan_lainnya"
                                name="tempat_pelayanan_lainnya"
                                value={value.tempat_pelayanan_lainnya || ''}
                                onChange={handleChange}
                                error={error.tempat_pelayanan_lainnya ? true : false}
                                helperText={error.tempat_pelayanan_lainnya}
                                inputProps={{
                                    className: classes.inputMini
                                }}
                            />}
                    </div></>;
            case '8':
                return <><div className={classes.radioSection}>
                        <FormControlLabel control={<Radio />}
                            value="1"
                            label="1. Rumah sakit umum" />
                        <FormControlLabel control={<Radio />}
                            value="2"
                            label="2. Rumah sakit khusus" />
                        <FormControlLabel control={<Radio />}
                            value="3"
                            label="3. Klinik utama" />
                        <FormControlLabel control={<Radio />}
                            value="4"
                            label="4. Puskesmas" />
                        <FormControlLabel control={<Radio />}
                            value="5"
                            label="5. Praktik dokter" />
                        <FormControlLabel control={<Radio />}
                            value="6"
                            label="6. Klinik pratama" />
                    </div>

                    <div className={classes.radioSection}>
                        <FormControlLabel control={<Radio />}
                            value="7"
                            label="7. Rumah sakit tipe D pratama" />
                        <FormControlLabel control={<Radio />}
                            value="8"
                            label="8. Tempat Praktik Mandiri Bidan (TPMB)" />
                        <FormControlLabel control={<Radio />}
                            value="9"
                            label="9. Pustu" />
                        <FormControlLabel control={<Radio />}
                            value="10"
                            label="10. Pusling" />
                        <FormControlLabel control={<Radio />}
                            value="11"
                            label="11. Poskesdes/polindes" />
                        <FormControlLabel control={<Radio />}
                            value="12"
                            label="12. Mobil pelayanan kontrasepsi" />
                    </div></>;
            default:
                return <><div className={classes.radioSection}>
                        <FormControlLabel control={<Radio />}
                            value="1"
                            label="1. Rumah sakit umum" />
                        <FormControlLabel control={<Radio />}
                            value="2"
                            label="2. Rumah sakit khusus" />
                        <FormControlLabel control={<Radio />}
                            value="3"
                            label="3. Klinik utama" />
                        <FormControlLabel control={<Radio />}
                            value="4"
                            label="4. Puskesmas" />
                        <FormControlLabel control={<Radio />}
                            value="5"
                            label="5. Praktik dokter" />
                        <FormControlLabel control={<Radio />}
                            value="6"
                            label="6. Klinik pratama" />
                        <FormControlLabel control={<Radio />}
                            value="7"
                            label="7. Rumah sakit tipe D pratama" />
                    </div>

                    <div className={classes.radioSection}>
                        <FormControlLabel control={<Radio />}
                            value="8"
                            label="8. Tempat Praktik Mandiri Bidan (TPMB)" />
                        <FormControlLabel control={<Radio />}
                            value="9"
                            label="9. Pustu" />
                        <FormControlLabel control={<Radio />}
                            value="10"
                            label="10. Pusling" />
                        <FormControlLabel control={<Radio />}
                            value="11"
                            label="11. Poskesdes/polindes" />
                        <FormControlLabel control={<Radio />}
                            value="12"
                            label="12. Mobil pelayanan kontrasepsi" />
                        <FormControlLabel control={<Radio />}
                            value="13"
                            label="13. Toko obat/apotek" />
                        <FormControlLabel control={<Radio />}
                            value="14"
                            label="14. Lainnya" />
                        {value.tempat_pelayanan === "14" &&
                            <TextField
                                fullWidth
                                placeholder="Tuliskan"
                                variant="outlined"
                                id="tempat_pelayanan_lainnya"
                                name="tempat_pelayanan_lainnya"
                                value={value.tempat_pelayanan_lainnya || ''}
                                onChange={handleChange}
                                error={error.tempat_pelayanan_lainnya ? true : false}
                                helperText={error.tempat_pelayanan_lainnya}
                                inputProps={{
                                    className: classes.inputMini
                                }}
                            />}
                    </div></>;
        }
    }

    return (
    <>
    <form id={id} onSubmit={handleSubmit} noValidate>
        <div className={classes.card}>
            <div className={classes.cardHeader}>
                <Typography margin="normal" paragraph>
                    <span className={classes.badge}>07</span>{pertanyaan}</Typography>
                <div style={{ position: "absolute", right: "0", top: "58px" }}>
                    <InfoButton
                        content={
                            "Tempat pelayanan KB dari responden (istri atau suami) mendapat pelayanan kontrasepsi yang digunakan saat ini atau terakhir dipakai. "+
                            "\nJika responden pada jenis kontrasepsi menjawab MAL, maka sumber tempat pelayanan KB adalah tempat responden mendapatkan informasi tentang MAL."
                        }
                    />
                </div>
            </div>
            <div className={classes.cardBody}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <FormControl error={error.tempat_pelayanan ? true : false} component="fieldset" fullWidth>
                            <RadioGroup value={value.tempat_pelayanan || ''}
                                onChange={handleChange}
                                aria-label="tempat_pelayanan" name="tempat_pelayanan"
                                className={classes.radioGroup}
                            >
                                {renderSwitchKB7(kb["0106"].jenis_kontrasepsi)}
                            </RadioGroup>

                            <FormHelperText>{error.tempat_pelayanan}</FormHelperText>
                        </FormControl>
                    </Grid>




                </Grid>
            </div>
        </div>
    </form>

    <Grid item xs style={{marginTop:20}}>
        <Button
            ref={backRef}
            // disabled={!isSomethingChange || isSubmitting}
            onClick={handleBackSub}><ChevronLeft className={classes.iconLeft} /> Sebelumnya </Button>

        {isSubmitting && <CircularProgress size={14} />}
        <Button
            style={{float: 'right'}}
            ref={nextRef}
            form={id}
            disabled={isSubmitting}
            type="submit">Selanjutnya <ChevronRight className={classes.iconRight} /></Button>
    </Grid>
    </>
    )
}

export default SubForm07;